<script>
	import Header from './Header.svelte';
	import Footer from './Footer.svelte';
</script>

<div class="layout">
	<Header />
	<main class="main-content">
		<slot />
	</main>
	<Footer />
</div>

<style>
	:global(html, body) {
		margin: 0;
		padding: 0;
		width: 100%;
		height: 100%;
	}

	.layout {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
		width: 100%;
	}

	.main-content {
		flex: 1;
		width: 100%;
	}
</style>
